'use client';
import Image from 'next/image';
export const TrustedBrands: React.FC = () => {
  const brandLogos = [
    { src: "/images/brands/cortem-group.png", alt: "Cortem Group Logo" },
    { src: "/images/brands/abb-logo.svg", alt: "ABB Logo" },
    { src: "/images/brands/continental-logo-300x71.png", alt: "Continental Logo" },
    { src: "/images/brands/Honeywell_Logo.png", alt: "Honeywell Logo" },
    { src: "/images/brands/Superior-Logo-e1667240416207-300x107.png", alt: "Superior Logo" },
    { src: "/images/brands/NSK-LOGO_WAJAX.jpg", alt: "NSK Logo" },
    { src: "/images/brands/Syntron-Material-Handling.jpg", alt: "Syntron Material Handling Logo" },
    { src: "/images/brands/Schaeffler-logo-300x34.png", alt: "Schaeffler Logo" },
    { src: "/images/brands/fireye-logo-e1628826874290-1200x660-1-300x165.jpg", alt: "Fireye Logo" },
    { src: "/images/brands/sew-logo-300x144.jpg", alt: "SEW Logo" },
    { src: "/images/brands/goodwin-submersible-pumps-logo-300x98.png", alt: "Goodwin Submersible Pumps Logo" },
    { src: "/images/brands/green-logo-w-arrows-300x68.jpg", alt: "Green Logo" },
    { src: "/images/brands/Renold-300x75.png", alt: "Renold Logo" },
    { src: "/images/brands/henkel.png", alt: "Henkel Logo" },
    { src: "/images/brands/LOCTITE-300x81.png", alt: "Loctite Logo" },
    { src: "/images/brands/Martin-300x122.png", alt: "Martin Logo" },
    { src: "/images/brands/Regal-Beloit.gif", alt: "Regal Beloit Logo" },
    { src: "/images/brands/robco_logo_red_300x108.png", alt: "Robco Logo" },
    { src: "/images/brands/WILO_Logo.jpg", alt: "Wilo Logo" },
    { src: "/images/brands/Wastecorp-logo-340x159-1-300x140.png", alt: "Wastecorp Logo" },
    { src: "/images/brands/TSUBAKI-300x64.jpg", alt: "Tsubaki Logo" },
    { src: "/images/brands/Tractel-300x58.png", alt: "Tractel Logo" },
    { src: "/images/brands/townleylogo.png", alt: "Townley Logo" },
    { src: "/images/brands/TIMKEN-300x64.png", alt: "Timken Logo" }
  ];

  return (
    <section className="bg-black text-white py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 text-center">
        {/* Section Title */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6 leading-tight">
          Trusted Brands
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-12 max-w-3xl mx-auto">
          We work closely with industry-leading manufacturers and OEMs to deliver quality without compromise.
        </p>

        {/* Optional: Our Partner Brands subtitle */}
        <p className="text-gray-400 text-lg font-semibold mb-8">Our Partner Brands</p>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-8 items-center justify-center max-w-6xl mx-auto">
          {brandLogos.map((logo, index) => (
            <div key={index} className="flex justify-center items-center"> {/* Removed p-4 bg-gray-800 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 */}
              <Image
                src={logo.src}
                alt={logo.alt}
                width={150}
                height={80}
                className="max-w-full h-auto max-h-20 object-contain"
              />
            </div>
          ))}
        </div>

        <p className="text-lg sm:text-xl text-gray-300 mt-12 max-w-3xl mx-auto">
          From precision instrumentation to robust construction machinery — we cover it all.
        </p>
      </div>
    </section>
  );
};

export default TrustedBrands;